import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const designAndConfiguration: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('admin-tabs.design-and-configuration') as string;
			},
		},
		path: 'design-and-configuration',
		name: Routes.GROUP_ADMIN_DESIGN_AND_CONFIGURATION,
		redirect: { name: Routes.GROUP_ADMIN_HIGHLIGHTS },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
			};
		},
		component: () => import(
			/* webpackChunkName: "group-admin-design-and-configuration" */
			'@front-app/views/home/group/admin/designAndConfiguration/DesignAndConfiguration.vue'
		),
		children: [
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('admin-tabs.pinned-highlights') as string;
					},
				},
				path: 'highlights',
				name: Routes.GROUP_ADMIN_HIGHLIGHTS,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
					};
				},
				component: () => import(
					/* webpackChunkName: "group-admin-highlights" */
					'@front-app/views/home/group/admin/designAndConfiguration/Highlights.vue'
				),
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('manage-categories.group-configuration') as string;
					},
				},
				path: 'categories',
				name: Routes.GROUP_ADMIN_DESIGN_AND_CONFIGURATION_CATEGORIES,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
					};
				},
				component: () => import(
					/* webpackChunkName: "group-admin-categories" */
					'@front-app/views/home/group/admin/designAndConfiguration/Categories.vue'
				),
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('admin-tabs.custom-page') as string;
					},
				},
				path: 'custom-page',
				name: Routes.GROUP_ADMIN_DESIGN_AND_CONFIGURATION_CUSTOM_PAGE,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
					};
				},
				component: () => import(
					/* webpackChunkName: "group-admin-custom-page" */
					'@front-app/views/home/group/admin/designAndConfiguration/CustomPage.vue'
				),
			},
		],
	},
];
